module.exports = __webpack_public_path__ + "static/media/usaApply03.7f2fd43d.jpg";